import {
  BaseFieldMappingFieldProps,
  FieldMappingData,
} from '@components/text-editors/addons/field-mapping';
import { SingleField } from '@components/text-editors/addons/single-field';

import { FieldMappingListField } from './field-mapping-list-field';

export type FieldMappingFieldProps = BaseFieldMappingFieldProps & FieldMappingData;

export const FieldMappingField = ({ defaultValue, onChange, ...rest }: FieldMappingFieldProps) => (
  <FieldMappingListField
    extensions={[SingleField]}
    defaultValue={defaultValue ? [defaultValue] : undefined}
    onChange={(value) => onChange?.(value[0])}
    {...rest}
  />
);
